import React, { useEffect, useState } from "react"

import { Row, Col, Card, CardBody, Form, Label, Button, Input } from "reactstrap"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import "../PublicPromoCode/datatables.scss"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import _ from 'lodash'
import Select from "react-select"
import Dropzone from "react-dropzone"
import { Link } from 'react-router-dom'
import SweetAlert from "react-bootstrap-sweetalert"
// MomentJS
import moment from 'moment'
import { frxAppOptions, happeningTypeOptions, mallOptions } from "../../common/constants";
// import actions
import { connect } from 'react-redux';
import {
  setAllCategories,
  setAllMerchants
} from "../../store/cms-actions/postActions";
import { CircularProgress } from "@material-ui/core";
import ReactQuill from "react-quill";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";
import { getWidgetOptions } from "../../WebApiCalls/WebApiCalls";


const AddSingleBanner = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" }
  ]


  const [token, setToken] = useState()
  const [selectedFiles, setselectedFiles] = useState([])
  const [selectedSection, setselectedSection] = useState()
  const [selectedPosition, setselectedPosition] = useState(null)
  const [widgetOptions, setWidgetOptions] = useState([])
  const [Estore, setEstore] = useState(false)
  const [Rewards, setRewards] = useState(false)
  const [FRXHome, setFRXHome] = useState(false)
  const [selectedStatus, setselectedStatus] = useState()
  const [acceptedFileSize, setAcceptedFileSize] = useState("")
  // const [image_url, setImage_URL] = useState()
  const [success_msg, setsuccess_msg] = useState(false)
  const [neverEnding, setNeverEnding] = useState(false)
  const [errorMessage, SetErrorMessage] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)
  const [selectedFRXSection, setselectedFRXSection] = useState(frxAppOptions[frxAppOptions.length-1])
  const [campaignMedium, setCampaignMedium] = useState([])
  const [pocuno, setPocuno] = useState(false)
  const [pocunoUrl,setPocunoUrl]= useState()
  const [externalUrl,setExternalUrl]=useState()
  const [externaLinkName,setExternalLinkName]=useState("")
  const [loader,setLoader]=useState(false)
  const [customCheck,setcustomCheck]=useState(false)
  const [customNavigation,setCustomNavigation]=useState()
  const [externalUrlErrorMessage,setExternalUrlErrorMessage]=useState('')
  const [selectedMall, setSelectedMall] = useState(null);
  const [selectedHappeningType, setSelectedHappeningType] = useState(null);



  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)
    getWidgetOptions(token).then(opts => setWidgetOptions(opts)).catch(() => {});
    if (props?.location?.state?.FRxHomeSingleBanners) {
      setFRXHome(true)
      setselectedSection({ value: "home_single", label: "FRx Home", path: 'frx-home-single-banners', medium: "HomeSingleBanner" })
      setCustomNavigation(JSON.stringify({"section":"","custom":true,"params":{"CampaignMedium":"HomeSingleBanner","link":""}}))
      setAcceptedFileSize('1210x630')
      setCampaignMedium("Single Banner")
    } else if (props?.location?.state?.RewardsSingle) {
      setRewards(true)
      setselectedSection({ value: "reward_single", label: "Rewards", path: 'rewards-single', medium: "RewardsSingleBanner" })
      setCustomNavigation(JSON.stringify({"section":"","custom":true,"params":{"CampaignMedium":"RewardsSingleBanner","link":""}}))
      setAcceptedFileSize('1210x630')
      setCampaignMedium("Single Banner")
    } else if (props?.location?.state?.EstoreSingleBanners) {
      setEstore(true)
      setselectedSection({ value: "estore_single", label: "EStore", path: 'estore-single',medium: "eStoreSingleBanner" })
      setAcceptedFileSize('1200x345')
    }
    setselectedStatus({ value: "Y", label: "Enable" })
  }, [])

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    let path = files[0].path
    path = path.split(".")
    path = path[1]
    if (path == "jpg"  || path == "JPG") {
      setselectedFiles(files)
    } else {
      SetErrorMessage("Please select a .jpg file")
      setErrorMsgAlert(true)
    }
  }



  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          if(props?.location?.state?.EstoreSingleBanner){
            props?.history.push(`/estore-home/single-banner`)
          }else{
          props?.history.push(`/single-banners/${selectedSection?.path}`)
          }
        }}
        onConfirm={() => {
          setsuccess_msg(false)
          setLoader(false)
          if(props?.location?.state?.EstoreSingleBanner){
            props?.history.push(`/estore-home/single-banner`)
          }else{
          props?.history.push(`/single-banners/${selectedSection?.path}`)
          }
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {"Single Banner Added."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }
  const validateFileSize = (file) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;

          if (width !== 600 || height !== 320) {
            SetErrorMessage("Height and Width must be 600x320px")
            setErrorMsgAlert(true)
            return false;
          }
          else if (props?.location?.state?.EstoreSingleBanners) {
          if (width !== 1200 || height !== 345) {
            SetErrorMessage("Width and Height must be 1200x345px")
            setErrorMsgAlert(true)
            // alert("Height and Width must be 600px.");
            return false;
          }
        }

        // alert("Uploaded image has valid Height and Width.");
        handleAcceptedFiles(file)
        return true;
      };
    };
  }

  async function handleSubmit() {
    const title = document.getElementById("title_input")?.value;
    const description = document.getElementById("description_input")?.value;
    let publishAt = moment(document.getElementById("publishAt_input").value).format("YYYY/MM/DD HH:mm");
    let unpublishAt = moment(document.getElementById("unpublishAt_input").value).format("YYYY/MM/DD HH:mm");
    const status = selectedStatus ? selectedStatus.value : ""
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    currentDate = currentDate.toString()
    const link = document.getElementById("campaign_link_input")?.value ? document.getElementById("campaign_link_input")?.value : ""
    const article_id = document.getElementById("article_id")?.value
    const titleFRX = document.getElementById("title_input_frx")?.value;
    if(!pocuno){
      if(!title){
      SetErrorMessage("Please Enter Title")
      setErrorMsgAlert(true)
      return
    }else if(!description){
      SetErrorMessage("Please Enter Description")
      setErrorMsgAlert(true)
      return
    }
    
    if(selectedFRXSection.value == "NA"){
      if(!externalUrl){
        SetErrorMessage("Please Enter URL")
        setErrorMsgAlert(true)
        return
      }else if(externalUrlErrorMessage){
        SetErrorMessage("Please enter valid URL")
        setErrorMsgAlert(true)
        return
      }else if(!checkTextInsideHtml(externaLinkName)){
        SetErrorMessage("Please Enter Exit Message Description")
        setErrorMsgAlert(true)
        return
      }
    }

     if(customCheck){
      if(!customNavigation){
        SetErrorMessage("Please Enter Navigation")
        setErrorMsgAlert(true)
        return
      }
  }

    if (!pocuno && selectedFiles.length < 1) {
      setErrorMsgAlert(true)
      SetErrorMessage("Please select image")
      return
    } else if (status == '') {
      setErrorMsgAlert(true)
      SetErrorMessage("Please select status")
      return
    }
  }

  if (publishAt == "Invalid date") {
    SetErrorMessage("Please select publish date")
    setErrorMsgAlert(true)
    return
  } else if (!neverEnding) {
    if(unpublishAt == "Invalid date"){
    SetErrorMessage("Please select unpublish date")
    setErrorMsgAlert(true)
    return
       }
    else if(unpublishAt < publishAt){
    SetErrorMessage("Unpublish date should be after the publish date")
    setErrorMsgAlert(true)
    return
             }
  }
    
    if(selectedSection?.value=="home_single"){
      if(pocuno && !pocunoUrl){
      setErrorMsgAlert(true)
      SetErrorMessage("Please Enter Pocuno Url")
      return
      }
    }


    if(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck){
      if(!link){
        SetErrorMessage("Please Enter campaign tracking name")
        setErrorMsgAlert(true)
        return
      }
    }
   setLoader(true)
    let _deeplinkObj = {
      section: '',
      params: {
        
      },
      website_params: {}
    }
if(!customCheck){
  if (pocuno) {
    _deeplinkObj.params.pocuno_ads = true
    _deeplinkObj.params.pocuno_url= pocunoUrl
    _deeplinkObj.section = "NA"
    _deeplinkObj.params.CampaignMedium = "NA"
    _deeplinkObj.params.link = "NA"
  } else {
    if (selectedFRXSection) {
      _deeplinkObj.section = selectedFRXSection.value;
      _deeplinkObj.params.CampaignMedium = selectedSection?.medium;
      _deeplinkObj.params.Link = link;
    
   if (selectedFRXSection.value == "rewards") {
      _deeplinkObj.section = "rewards"
      _deeplinkObj.params.tab = 2
      _deeplinkObj.params.option_selected = 1
      _deeplinkObj.params.sub_section_option = 1
      _deeplinkObj.params.CampaignMedium = selectedSection?.medium
      _deeplinkObj.params.link = link
    }else if (selectedFRXSection.value == "NA") {
       _deeplinkObj={}
       _deeplinkObj.section = "NA";
       _deeplinkObj.url=externalUrl;
       _deeplinkObj.external_link_name=externaLinkName;       
    }else if (selectedFRXSection.value == "UobUni") {
       _deeplinkObj.section = "UobUni";
    }else if (selectedFRXSection.value == "ShowQR") {
       _deeplinkObj.section = "ShowQR";
    }else if (selectedFRXSection.value == "digital_gift_card") {
      _deeplinkObj.params.CampaignMedium = selectedSection?.medium
      _deeplinkObj.params.link = link
      _deeplinkObj.section = "digital_gift_card";
      _deeplinkObj.params._params ="digital_gift_card_listing";
    }else if(selectedFRXSection?.value == "FRxMemberSpending"){
      _deeplinkObj.login_required = true
      _deeplinkObj.params.link = link
    }else if (selectedFRXSection.value == "add_gift_card") {
      _deeplinkObj.params.CampaignMedium = selectedSection?.medium
      _deeplinkObj.params.link = link
      _deeplinkObj.section = "digital_gift_card";
      _deeplinkObj.params.show_add_selection_modal = true;
    }else if (selectedFRXSection.value == "buy_gift_card") {
      _deeplinkObj.params.CampaignMedium = selectedSection?.medium
      _deeplinkObj.params.link = link
      _deeplinkObj.section = "digital_gift_card";
      _deeplinkObj.params.show_buy_selection_modal = true;
    } else if (selectedFRXSection.value == "ewallet") {
      _deeplinkObj.section = "ewallet"
      _deeplinkObj.params = selectedFRXSection.params
      _deeplinkObj.params.CampaignMedium = selectedSection?.medium
      _deeplinkObj.params.link = link
    } else if (selectedFRXSection.value == "ArticleDetail") {
      _deeplinkObj.section = selectedFRXSection.value
      _deeplinkObj.params.data = `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`
      _deeplinkObj.params.title = titleFRX
      _deeplinkObj.params.CampaignMedium = selectedSection?.medium
      _deeplinkObj.params.link = link
      _deeplinkObj.params.article = { category: titleFRX, id: `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`}      
    }else if (selectedFRXSection.value == "BuyForMySelf") {
      _deeplinkObj.params.buy_for="me"
   }else if (selectedFRXSection.value == "No Navigation") {
    _deeplinkObj = " ";
  } 
  }
}
}


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var formdata = new FormData();
    formdata.append("path", "tiles_banners/add");
    formdata.append("env", "staging");
    formdata.append("page", selectedSection?.value);
    formdata.append("item_status", status);
    formdata.append("title",pocuno ? "NA" : title)
    formdata.append("description", pocuno ? "NA" : description);
    formdata.append("item_version", 18);
    formdata.append("deeplink",customCheck ? customNavigation : JSON.stringify(_deeplinkObj));
    formdata.append("published_at", publishAt);
    formdata.append("unpublished_at", neverEnding ? null : unpublishAt);
    formdata.append("sort_order", selectedPosition?.value ?? "");
    formdata.append("api", true);
    if (!pocuno) {
      formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    }
    else {
          let response = await fetch('https://frxassets.tgate.sg/icons/Pocuno-Default.jpg');
          let data = await response.blob()
          console.log("data",data)
          let file = new File([data], "download.jpg");
          formdata.append("userfile",file, "download.jpg")
          }

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result) {
          if (result?.Items?.length > 0) {
            setLoader(false)
            setsuccess_msg(true)
          }
        } else {
          SetErrorMessage("Unable to Add Single Banner")
          setErrorMsgAlert(true)
          setLoader(false)
        }
      })
      .catch(error => console.log('error', error));
  }
  const checkCharacterCount = (e, count) => {
    if (e.target.innerText.length > count && e.key !== 'Backspace') {
      e.preventDefault()
    }
  }

  const checkTextInsideHtml = (htmlString) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/;
    const matchBookingInfo = regex.exec(htmlString);
    if (matchBookingInfo && matchBookingInfo[1]) {
      return true;
    } else {
      const simpleStringRegex = /^[^<>\n]+$/;
      return simpleStringRegex.test(htmlString);
    }
  };
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const handleExternalUrl = (value) =>{
    setExternalUrl(value)
    var pattern = /^(https:\/\/|http:\/\/)([a-z]{2,})\.([a-zA-Z0-9-]{2,})+\.[a-z]{2,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
    if(value){
      if (!pattern.test(value)) {
        setExternalUrlErrorMessage("Please enter valid URL (Including https://)");
      } else {
        setExternalUrlErrorMessage("");
      }
    }else{
      setExternalUrlErrorMessage("");
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Single Banners"
            breadcrumbItem="Add Single Banner"
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Card>
                    <CardBody>
                      
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form className="" method="post" id="tooltipForm">
                          <div>
                            <Row>
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>Position</Label>
                                  <div className="col-md-12">
                                    <Select
                                      options={widgetOptions}
                                      value={selectedPosition}
                                      onChange={(option) => setselectedPosition(option)}
                                      placeholder="Select Position..."
                                    />
                                  </div>
                                </div>
                              </Col>

                              <Col md={1}></Col>
                            </Row>

                            {pocuno && (
                              <Row>
                                <Col lg={4} md={6} sm={6}>
                                  <div className="mb-4">
                                    <Label>Url</Label>
                                    <input
                                      onChange={(e) => {
                                        setPocunoUrl(e.target.value);
                                      }}
                                      className="form-control"
                                      type="text"
                                      id="url_input"
                                      value={pocunoUrl}
                                      min={1}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            )}
                            <Row>
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>Title</Label>
                                  <div className="col-md-12">
                                    <input
                                      className="form-control"
                                      type="text"
                                      defaultValue=""
                                      id="title_input"
                                      disabled={pocuno}
                                      maxLength="51"
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>Description</Label>
                                  <div className="col-md-12">
                                    <input
                                      className="form-control"
                                      type="text"
                                      defaultValue=""
                                      id="description_input"
                                      disabled={pocuno}
                                      maxLength="60"
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={4} md={6} sm={6}>
                                <Row className="mb-3">
                                  <Label>Navigate to</Label>
                                  {customCheck ? 
                                        <textarea
                                        rows={4}
                                        col={20}
                                        disabled={pocuno}
                                        type="text"
                                        className="form-control"
                                        id="item_group_input"
                                        onChange={(e) => {
                                          setCustomNavigation(e.target.value);
                                        }}
                                        defaultValue={customNavigation}
                                      />
                                      :<Select
                                    isSearchable={true}
                                    value={selectedFRXSection}
                                    onChange={(e) => {
                                      setselectedFRXSection(e);
                                      if (e.label == "eStore") {
                                        setEstore(true);
                                      } else {
                                        setEstore(false);
                                      }
                                    }}
                                    placeholder={
                                      selectedFRXSection?.label
                                        ? selectedFRXSection?.label
                                        : "Choose section..."
                                    }
                                    defaultValue={frxAppOptions[0]}
                                    options={frxAppOptions}
                                    required
                                    isDisabled={pocuno}
                                  />}
                                </Row>
                              </Col>
                              <Col md={1}>
                                
                              </Col>
                                  {!pocuno && <Col md={2} style={{paddingTop:"38px"}}>
                                  <div className="form-check form-switch">
                                    <input
                                      type="checkbox"
                                      className="form-check-input checkbox"
                                      id="checkbox_custom_nav"
                                      value={customCheck}
                                      defaultChecked={customCheck}
                                      onClick={() => { 
                                      setcustomCheck(!customCheck)
                                      }}
                                    />

                                    <label className="form-check-label" htmlFor="checkbox_pocuno">
                                      Custom Navigation
                                    </label>
                                  </div>
                                  </Col>}
                            </Row>
                            <Row>
                            {(selectedFRXSection?.label == "External Link" && !customCheck) &&
                                  <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3">
                                      <Label>URL*</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue=""
                                        disabled={pocuno}
                                        id="external_url_input"
                                        onChange={(e) => {
                                          handleExternalUrl(e.target.value)}}
                                      />
                                       {externalUrlErrorMessage && (
                                      <p style={{ color: "red", fontSize: 12 }}>
                                        {externalUrlErrorMessage}
                                      </p>
                                    )}
                                    </div>
                                  </Col>}
                            </Row>
                            <Row>
                                  {(selectedFRXSection?.label == "External Link" && !customCheck) &&
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>{"Exit Message Description*"}</Label>
                                        <ReactQuill
                                          modules={{
                                            toolbar: [
                                              ["bold", "italic", "underline"],
                                              [{ list: "ordered" }, { list: "bullet" }],
                                              ["link", { color: [] }],
                                              ["clean"],
                                            ],
                                          }}
                                          theme="snow"
                                          value={externaLinkName}
                                          onChange={(e, delta, source, c) => {
                                            if (c.getText().length <= 2000) {
                                              setExternalLinkName(e);
                                            } else if (c.getText().length > 2000) {
                                              const remainingCharacters = 2000 - c.getText().length;
                                              let truncatedText = c.getText().slice(0, remainingCharacters);
                                              setExternalLinkName(truncatedText)
                                            }
                                          }}
                                          onKeyDown={(e) => checkCharacterCount(e, 2000)}

                                          style={{ minHeight: "30px" }}
                                        />
                                      </div>
                                    </Col>}
                                  <Col md={1}></Col>
                                </Row>

                             {/* ArticleDetail section */}
                              {(selectedFRXSection?.value == "ArticleDetail" && !customCheck) && (
                                <>
                                  <Row>
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>Mall</Label>
                                        <Select
                                          isSearchable={true}
                                          onChange={(e) => {
                                            setSelectedMall(e);
                                            setSelectedHappeningType(null);
                                          }}
                                          options={mallOptions}
                                          placeholder="Select Mall..."
                                          value={selectedMall}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  
                                  {selectedMall && (
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Type</Label>
                                          <Select
                                            isSearchable={true}
                                            onChange={(e) => {
                                              setSelectedHappeningType(e);
                                            }}
                                            options={happeningTypeOptions}
                                            placeholder="Select Happening Type..."
                                            value={selectedHappeningType}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  
                                  {selectedHappeningType && (
                                    <>
                                      <Row>
                                        <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                         <Label>Blog ID</Label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue=""
                                            id="article_id"
                                          />
                                        </div>
                                        </Col>
                                      </Row>
                                      <Row >
                                        <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                        <Label>Header Title</Label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue=""
                                            id="title_input_frx"
                                          />
                                        </div>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </>
                              )}
                          </div>
                         {(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck)  && (
                              <Row>
                                <Col lg={4} md={6} sm={6}>
                                  <div className="mb-3">
                                    <Label>Campaign Tracking Name</Label>
                                    <input
                                      className="form-control"
                                      type="text"
                                      defaultValue=""
                                      id="campaign_link_input"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            )}
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Form>
                    <Dropzone
                      onDrop={(acceptedFiles) => {
                        if (props?.location?.state?.FRxHomeSingleBanners) {
                          validateFileSize(acceptedFiles);
                          // handleAcceptedFiles(acceptedFiles)
                        } else if (props?.location?.state?.RewardsSingle) {
                          validateFileSize(acceptedFiles);
                          // handleAcceptedFiles(acceptedFiles)
                        } else if (
                          props?.location?.state?.EstoreSingleBanners
                        ) {
                          validateFileSize(acceptedFiles);
                        }
                      }}
                      disabled={pocuno}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div
                          className="dropzone"
                          style={{ background: pocuno ? "#F5F6F8" : "" }}
                        >
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <FaCloudUploadAlt className="display-4 text-muted"/>
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                            {!pocuno && (
                              <p style={{ fontSize: 12, color: "red" }}>
                                Image should be 600X320px in jpg.
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        );
                      })}
                    </div>
                  </Form>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={4} md={6} sm={6}>
                      <div className="mb-3">
                        <Label>Publish At</Label>
                        <div className="col-md-12">
                          <input
                            className="form-control"
                            type="datetime-local"
                            id="publishAt_input"
                            defaultValue={""}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={1}></Col>
                    <Col lg={4} md={6} sm={6}>
                      <div className="mb-3">
                        <Label>Unpublish At</Label>
                        <div className="col-md-12">
                          <input
                            disabled={neverEnding}
                            className="form-control"
                            type="datetime-local"
                            id="unpublishAt_input"
                            defaultValue={""}
                            min={""}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col style={{ paddingTop: 35 }}>
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input checkbox"
                          id="checkbox_1"
                          checked={neverEnding}
                          onChange={() => {
                            setNeverEnding(!neverEnding);
                          }}
                        />

                        <label
                          className="form-check-label"
                          htmlFor="checkbox_1"
                        >
                          Never-ending
                        </label>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={4} md={6} sm={6}>
                      <div className="mb-3">
                        <Label>Status</Label>
                        <Select
                          // isSearchable={true}
                          value={selectedStatus}
                          onChange={(e) => {
                            setselectedStatus(e);
                          }}
                          placeholder={
                            selectedStatus ? selectedStatus.label : "Choose..."
                          }
                          defaultValue={statusOptions[0].value}
                          options={statusOptions}
                          required
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              {success_msg ? renderSuccessAlert() : null}
              {errorMsgAlert ? renderFailureAlert() : null}
              <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props?.history?.goBack();
                        }}
                        color="danger"
                        type="submit"
                      >
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          handleSubmit();
                        }}
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
              </div>
              </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AddSingleBanner